import { render } from "./SkeletonLoader.vue?vue&type=template&id=4ab1460e"
const script = {}

import "./SkeletonLoader.vue?vue&type=style&index=0&id=4ab1460e&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__